import { Routes } from '@angular/router'
import { FeatureType, RouteUtil } from '../shared'
import { MaterialLocationQuantitiesComponent } from './material-location-quantities/material-location-quantities.component'
import { SmallToolLocationsComponent } from './small-tool-locations/small-tool-locations.component'
import { MaterialTransferComponent } from './material-transfer/material-transfer.component'
import { MaterialTransferRecordsComponent } from './material-transfer-records/material-transfer-records.component'
import { EmployeeAssetsComponent } from './employee-assets/employee-assets.component'
import { BarcodeManagerComponent } from './barcode-manager/barcode-manager.component'

export const toolRoomRoutes: Routes = [
    {
        path: 'tool-room',
        children: [
            RouteUtil.Make('tool-transfer', MaterialTransferComponent, FeatureType.ToolRoomTransfers),
            RouteUtil.Make('material-quantities', MaterialLocationQuantitiesComponent, FeatureType.ToolRoomRecordsView),
            RouteUtil.Make('small-tool-locations', SmallToolLocationsComponent, FeatureType.ToolRoomRecordsView),
            RouteUtil.Make('tool-transfer-records', MaterialTransferRecordsComponent, FeatureType.ToolRoomRecordsView),
            RouteUtil.Make('employee-assets', EmployeeAssetsComponent, FeatureType.ToolRoomEmployeeAssetsView),
            RouteUtil.Make('barcode-manager', BarcodeManagerComponent, FeatureType.ToolRoomRecordsView),
        ],
    },
]
